var map = {
	"./calendar.svg": [
		3734,
		734
	],
	"./check.svg": [
		7325,
		325
	],
	"./chevron.svg": [
		4448,
		955
	],
	"./child.svg": [
		3518,
		518
	],
	"./clock.svg": [
		9794,
		794
	],
	"./cross.svg": [
		7591,
		591
	],
	"./excel.svg": [
		8274,
		274
	],
	"./eye.svg": [
		4245,
		245
	],
	"./female.svg": [
		4501,
		501
	],
	"./male-female.svg": [
		6964,
		964
	],
	"./male.svg": [
		6036,
		36
	],
	"./park.svg": [
		5706,
		706
	],
	"./pen.svg": [
		8931,
		931
	],
	"./play.svg": [
		6128,
		128
	],
	"./plus.svg": [
		732,
		732
	],
	"./program-type.svg": [
		2025,
		25
	],
	"./programs-1.svg": [
		3886,
		886
	],
	"./programs-2.svg": [
		6909,
		909
	],
	"./settings.svg": [
		7364,
		364
	],
	"./slider-arrow.svg": [
		3345,
		345
	],
	"./tshirt.svg": [
		1458,
		458
	],
	"./upload-image.svg": [
		9990,
		990
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8280;
module.exports = webpackAsyncContext;